import {createContext} from 'react';

const documentosContext = createContext();

export default documentosContext;